<template>
    <div class="newadd">
        <div class="nav">
            <a href="javascript:" :class="{'nav-active':index == active}" v-for="(item,index) in navs" :key="index" @click="bindActive($event,{name:item.name,index:index,type:item.type})">{{item.name}}</a>
        </div>
        <div id="can"></div>
    </div>
</template>

<script>
    export default {
        name:"newadd",
        data(){
            return {
                navs:[
                    {name:"浏览量",type:"browse"},
                    {name:"访问量",type:"visit"},
                    {name:"事件发生数",type:"operate"},
                    {name:"停留时长",type:"stayTime"}
                ],
                showType:"browse",
                active:0,
                echartsTitle:"浏览量",
                echartsType:"柱状",
                // canvas图表数据
                chartAxis:['重庆站','杭州站','乐玛站','儿童站'],//底部显示数据
                chartLegend:['重庆站','杭州站','乐玛站','儿童站'],//每条柱状标识的内容
                chartSeries:{}, //图表数据
                chartSeriesTitle:["重庆站","杭州站","乐玛站","儿童站"], //与chartLengend对应的数据
                chartSeriesOption:"",
                // 切换显示状态（时间发生数）
                chartWidth:"50%",
                chartGpa:"-100%"
            }
        },
        mounted(){
            var _this = this;
            $.ajax({
                url:webUrl+"/active/getAllCount",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                dataType:"JSON",
                success(res){
                    _this.bindDisposeData(res.data);
                    setTimeout(function(){
                        _this.echartsInit()
                    }, 1);
                }
            })
        },
        methods:{
            echartsInit(){
                var myChart = echarts.init(document.getElementById("can"));
                var option = {
                    color: ['#337ab7','#8e222d', '#ff8a00', '#e04a4b','#248404'],
                    title: {
                        text: this.echartsTitle+"("+this.echartsType+")展示"
                    },
                    tooltip: {},
                    legend: {
                        data:this.chartLegend
                    },
                    xAxis: {
                        data: this.chartAxis
                    },
                    yAxis: {},
                    series: [{
                        name: this.chartSeriesTitle[0],
                        type: 'bar',
                        barWidth:this.chartWidth,
                        barGap:this.chartGpa,
                        data: this.chartSeries[this.showType][0]
                    },{
                        name: this.chartSeriesTitle[1],
                        type: 'bar',
                        barWidth:this.chartWidth,
                        barGap:this.chartGpa,
                        data:  this.chartSeries[this.showType][1]
                    },{
                        name: this.chartSeriesTitle[2],
                        type: 'bar',
                        barWidth:this.chartWidth,
                        barGap:this.chartGpa,
                        data:  this.chartSeries[this.showType][2]
                    },{
                        name: this.chartSeriesTitle[3],
                        type: 'bar',
                        barWidth:this.chartWidth,
                        barGap:this.chartGpa,
                        data: this.chartSeries[this.showType][3]
                    },{
                        name: this.chartSeriesTitle[4],
                        type: 'bar',
                        barWidth:this.chartWidth,
                        barGap:this.chartGpa,
                        data:  this.chartSeries[this.showType][4]
                    }]
                };
                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            },
            bindActive(event,db){
                this.echartsTitle  = db.name; //left title
                this.active = db.index; //要选择的数组索引 
                this.showType = db.type //要选择的数组对象 键
                if(db.name == "事件发生数"){
                    this.chartLegend = ["登录","注册","预约","分享","总量"]
                    this.chartSeriesTitle = ["登录","注册","预约","分享","全部"]
                    this.chartGpa = "20%"
                    this.chartWidth = "15%"
                }else{
                    this.chartLegend = ['重庆站','杭州站','乐玛站','儿童站']
                    this.chartSeriesTitle = ["重庆站","杭州站","乐玛站","儿童站"]
                    this.chartGpa = "-100%"
                    this.chartWidth = "50%"
                }
                this.echartsInit()
            },
            bindDisposeData(data){
                var len = Object.keys(data.browse).length +1
                for(var i in data){
                    var arr = [];
                    var operateLogin = [] ,operateSign = [] ,operateOrder = [] ,operateShare = [] ,operateAll = [] ;
                    for(var j in data[i]){
                        if(i === "stayTime"){
                            var minArr = []
                            for(var x = 1;x < len;x++){
                                if(x == j){
                                    minArr.push(data[i][j].stayTime)
                                }else{
                                    minArr.push(0)
                                }
                            }
                            arr.push(minArr)
                        }else if( i === "operate"){
                            var db = data[i][j];
                            var all = db.login+db.sign+db.order+db.share
                            operateLogin.push(db.login)
                            operateSign.push(db.sign)
                            operateOrder.push(db.order)
                            operateShare.push(db.share)
                            operateAll.push(all)
                        }else{
                            var minArr = []
                            for(var x = 1;x < len;x++){
                                if(x == j){
                                    minArr.push(data[i][j].count)
                                }else{
                                    minArr.push(0)
                                }
                            }
                            arr.push(minArr)
                        }
                    }
                    if(i === "operate"){
                        arr.push(operateLogin,operateSign,operateOrder,operateShare,operateAll);
                    }
                    this.chartSeries[i] = arr
                }
            }
        }
    }
</script>

<style scoped>
.newadd {
    text-align: left;
}
.nav {
    display: inline-block;
    font-size: 0;
    border-top: 1px #dbdbdb solid;
    border-left: 1px #dbdbdb solid;
}
.nav a {
    display: inline-block;
    width: 140px;
    text-align: center;
    font-size: 14px;
    color: #333;
    padding: 12px 0;
    transition-duration: 600ms;
    background-color: #f3f3f3;
    border-right: 1px #dbdbdb solid;
    border-bottom: 1px #dbdbdb solid;
}
.nav a:hover {
    opacity: 1;
    background-color: #fff;
    border-bottom-color: transparent;
}
.nav  .nav-active {
    background-color: #fff;
    border-bottom-color: transparent;
}
@media screen and (max-width:1280px) {
    .nav {
        width: 100%;
    }
    .nav a {
        width: 16.66%;
    }
}

/*canvas  图表*/
#can {
    padding-top:60px; 
    width: 900px;
    height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/affairpandect.vue